import React, { Suspense } from 'react';
const ListingView = React.lazy(() => Promise.resolve(require('./ListingView')));

const ListingViewLazy = (props) => (
    <Suspense fallback={<div>Loading...</div>}>
        <ListingView {...props} />
    </Suspense>
)

export default ListingViewLazy


// WEBPACK FOOTER //
// ./src/routes/Listing/components/ListingViewLazy.js